import { ICalendarLesson, ICalendarSlot, TLessonStatus } from "../../../entities/calendar";
import { getCalendarDayEventLayout } from "../../../shared/lib/helpers/calendarDayEventLayout";
import { getVisibleRange } from "./date";
import { IDisplayedPositionedLesson, IGroupedLessons, IPositionedLesson } from "./types";

const LESSON_STATUS_ORDER: readonly TLessonStatus[] = [
    'LESSON_STATUS_SCHEDULED',
    'LESSON_STATUS_RESCHEDULED',
    'LESSON_STATUS_CANCELLED',
    'LESSON_STATUS_COMPLETED',
    'LESSON_STATUS_UNSPECIFIED',
]

export const getCalendarSlotsByIndex = (slots: ICalendarSlot[], date: Date): Map<number, ICalendarSlot> => {
    const result = new Map<number, ICalendarSlot>()

    slots.forEach(slot => {
        const visibleRange = getVisibleRange(date, slot.startsAt, slot.durationSlots)

        if(!visibleRange) return

        for(let index = visibleRange.startIndex; index < visibleRange.endIndex; index++){
            const currentSlot = result.get(index)

            result.set(index, currentSlot
                ? {
                    ...currentSlot,
                    isAvailableForNewLesson: currentSlot.isAvailableForNewLesson && slot.isAvailableForNewLesson,
                    availableActions: currentSlot.availableActions.length ? currentSlot.availableActions : slot.availableActions,
                    lessons: [
                        ...currentSlot.lessons,
                        ...slot.lessons.filter(lesson => !currentSlot.lessons.some(currentLesson => currentLesson.id === lesson.id)),
                    ],
                }
                : slot
            )
        }
    })

    return result
}

export const getPositionedLessons = (slots: ICalendarSlot[], date: Date): IPositionedLesson[] => {
    const lessonsById = new Map<string, ICalendarLesson>()

    slots.forEach(slot => {
        slot.lessons.forEach(lesson => lessonsById.set(lesson.id, lesson))
    })

    return [...lessonsById.values()]
        .map(lesson => {
            const visibleRange = getVisibleRange(date, lesson.startsAt, lesson.durationSlots)

            return visibleRange ? {lesson, ...visibleRange} : null
        })
        .filter((item): item is IPositionedLesson => Boolean(item))
        .sort((first, second) => (
            first.startIndex - second.startIndex ||
            second.endIndex - first.endIndex
        ))
}

export const getCalendarLessonLayout = (
    positionedLessons: IPositionedLesson[],
    groupSingleLessons = false,
): {visibleLessons: IDisplayedPositionedLesson[]; groupedLessons: IGroupedLessons[]} => {
    const {visibleEvents, groupedEvents} = getCalendarDayEventLayout(
        positionedLessons,
        LESSON_STATUS_ORDER,
        positionedLesson => positionedLesson.lesson.status,
        groupSingleLessons,
    )

    return {
        visibleLessons: visibleEvents,
        groupedLessons: groupedEvents,
    }
}
